<template>
  <div class="mapa-cotacao-zoom-controls" aria-label="Controle de zoom do mapa">
    <v-btn
      small
      outlined
      color="primary"
      class="mapa-cotacao-zoom-button"
      :disabled="value <= min"
      aria-label="Reduzir zoom do mapa"
      @click="$emit('decrease')"
    >
      -
    </v-btn>
    <span class="mapa-cotacao-zoom-value">{{ value }}%</span>
    <v-btn
      small
      outlined
      color="primary"
      class="mapa-cotacao-zoom-button"
      :disabled="value >= max"
      aria-label="Aumentar zoom do mapa"
      @click="$emit('increase')"
    >
      +
    </v-btn>
    <v-btn
      small
      text
      color="primary"
      class="mapa-cotacao-zoom-reset"
      :disabled="value === defaultValue"
      @click="$emit('reset')"
    >
      Restaurar
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "MapaCotacaoZoomControls",
  props: {
    value: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 70,
    },
    max: {
      type: Number,
      default: 120,
    },
    defaultValue: {
      type: Number,
      default: 100,
    },
  },
};
</script>
